import React, { FormEvent, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import Appbar from 'components/appbar/Appbar';
import InsideLoading from 'components/loading/InsideLoading';
import InsideSaving from 'components/loading/InsideSaving';
import {
  ContentPad,
  PageShell,
  RecordFooter,
  RecordHeader,
  StyledForm,
  WorkArea,
} from 'components/record-shell/RecordShell';
import { api } from 'services/api';
import history from 'services/history';
import { AccessRule } from 'types/accessRule';
import { UserProfile } from 'types/userProfile';
import ProfileForm, { ProfileValidation } from '../ProfileForm';
import { toggleRule } from '../profileRules';

const NewProfile: React.FC = () => {
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [validation, setValidation] = useState<ProfileValidation>({});
  const [accessRules, setAccessRules] = useState<AccessRule[]>([]);
  const [userProfile, setUserProfile] = useState<UserProfile>({
    id: new Date().getTime(),
    name: '',
    access_rules: [],
  });

  useEffect(() => {
    api
      .get<AccessRule[]>('/access-rules-parents')
      .then(response => setAccessRules(response.data))
      .catch(err => {
        toast.error(err.response?.data?.error || 'Não foi possível carregar as permissões');
      })
      .finally(() => setLoading(false));
  }, []);

  function goBack() {
    history.push('/user-profiles');
  }

  function handleSubmit() {
    setSaving(true);

    api
      .post('/user-profiles', { userProfile, accessRules })
      .then(response => {
        toast.success('Perfil cadastrado');
        // abre o perfil recém-cadastrado
        history.push(response.data?.id ? `/user-profile/${response.data.id}` : '/user-profiles');
      })
      .catch(err => {
        toast.error(err.response?.data?.error || 'Não foi possível salvar o perfil');
      })
      .finally(() => setSaving(false));
  }

  function handleValidation(e?: FormEvent<HTMLFormElement>) {
    e?.preventDefault();

    yup
      .object()
      .shape({ name: yup.string().required('O nome é obrigatório') })
      .validate(userProfile)
      .then(() => {
        handleSubmit();
        setValidation({});
      })
      .catch(err => setValidation({ [err.path]: err.message }));
  }

  return (
    <>
      <Appbar title="Perfis de usuário" backAction={goBack} />

      {saving && <InsideSaving />}

      <PageShell>
        <RecordHeader title="Novo perfil" backAction={goBack} />

        <WorkArea>
          <ContentPad>
            {loading ? (
              <InsideLoading />
            ) : (
              <StyledForm onSubmit={handleValidation}>
                <ProfileForm
                  name={userProfile.name}
                  onNameChange={value => setUserProfile(old => ({ ...old, name: value }))}
                  validation={validation}
                  accessRules={accessRules}
                  onToggleRule={ruleId => setAccessRules(rules => toggleRule(rules, ruleId))}
                />
                <button type="submit" style={{ display: 'none' }}></button>
              </StyledForm>
            )}
          </ContentPad>
        </WorkArea>

        <RecordFooter>
          <Button variant="contained" size="small" disabled={saving} onClick={() => handleValidation()}>
            Salvar perfil
          </Button>
        </RecordFooter>
      </PageShell>
    </>
  );
};

export default NewProfile;
